var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_1469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_1469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.175 16.1L9.975 11.9C9.6 12.2 9.16875 12.4375 8.68125 12.6125C8.19375 12.7875 7.675 12.875 7.125 12.875C5.7625 12.875 4.6095 12.4032 3.666 11.4598C2.722 10.5157 2.25 9.3625 2.25 8C2.25 6.6375 2.722 5.48425 3.666 4.54025C4.6095 3.59675 5.7625 3.125 7.125 3.125C8.4875 3.125 9.64075 3.59675 10.5848 4.54025C11.5282 5.48425 12 6.6375 12 8C12 8.55 11.9125 9.06875 11.7375 9.55625C11.5625 10.0437 11.325 10.475 11.025 10.85L15.2438 15.0687C15.3813 15.2062 15.45 15.375 15.45 15.575C15.45 15.775 15.375 15.95 15.225 16.1C15.0875 16.2375 14.9125 16.3063 14.7 16.3063C14.4875 16.3063 14.3125 16.2375 14.175 16.1ZM7.125 11.375C8.0625 11.375 8.8595 11.047 9.516 10.391C10.172 9.7345 10.5 8.9375 10.5 8C10.5 7.0625 10.172 6.2655 9.516 5.609C8.8595 4.953 8.0625 4.625 7.125 4.625C6.1875 4.625 5.3905 4.953 4.734 5.609C4.078 6.2655 3.75 7.0625 3.75 8C3.75 8.9375 4.078 9.7345 4.734 10.391C5.3905 11.047 6.1875 11.375 7.125 11.375Z",
    fill: "#595959"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.eddf876cd6af687b49eb3b152f488ee8.svg";
export { ForwardRef as ReactComponent };